import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppThunk } from "./store";
import { ServiceLocater, Services } from "../service-locater";
import {
  ProductsRepository,
  Loading,
  Product,
  ProductsFailure,
} from "../domain";

type ProductState = {
  loading: Loading;
  failure?: ProductsFailure;
  product?: Product;
};

const initialState: ProductState = {
  loading: "idle",
};

const productSlice = createSlice({
  name: "product",
  initialState,
  reducers: {
    productLoading(state) {
      state.failure = undefined;
      state.product = undefined;
      state.loading = "pending";
    },
    productSuccess(state, action) {
      state.product = action.payload;
      state.loading = "succeeded";
    },
    productFailure(state, { payload }: PayloadAction<ProductsFailure>) {
      state.failure = payload;
      state.loading = "failed";
    },
  },
});

export default productSlice.reducer;

const { productLoading, productSuccess, productFailure } = productSlice.actions;

export const loadProduct = (id: string): AppThunk => async (dispatch) => {
  dispatch(productLoading());
  const res = await ServiceLocater.get<ProductsRepository>(
    Services.ProductsRepository
  ).getProductInfo(id);
  res.fold(
    (l) => {
      dispatch(productFailure(l));
    },
    (r) => dispatch(productSuccess(r))
  );
};
